import { func } from "prop-types";
import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { ReactComponent as Warning } from 'assets/images/svg/warning.svg';
import { ReactComponent as Download } from 'assets/images/svg/download.svg';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { checkCarNumber, deleteCarNumber, deleteWaverBarNumber, getCarList, saveCarExcel, saveCarNumber, } from "crud/auth.crud";
import Pagination from "pages/Custom/Pagination";

import _ from "lodash";
import moment from "moment";
import Util from "pages/Dashboard/Common/Util";

// import images
import weaver from "../../assets/images/weaver.png";
import loading from "../../assets/images/loading.gif";

const CarNumberManagementScreen = () => {
  const selector = useSelector(state => state)

  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [reset, setReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [carNumber, setCarNumber] = useState('');
  const [carNumberConfirm, setCarNumberConfirm] = useState(false);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group?.id);
  const [myId, setMyId] = useState(selector.auth?.user?.id);
  const [carListFile, setCarListFile] = useState([]);
  const [pagesGroup, setPagesGroup] = useState(1)
  const [pageArr, setPageArr] = useState([pagesGroup, pagesGroup + 1, pagesGroup + 2, pagesGroup + 3, pagesGroup + 4])
  const [contentCount, setContentCount] = useState()
  const [onUpload, setOnUpload] = useState(false)

  const getDataList = async () => {
    setOnUpload(true)

    let params = {
      page: page,
      company: companyId
    }

    const response = await getCarList(params);
    const content = response.data?.results || [];
    let dataCount = response.data.count % 15 === 0 ? response.data.count / 15 : Math.floor(response.data.count / 15) + 1
    if (!contentCount || contentCount !== dataCount) {
      if(dataCount === 0){
        setContentCount(1)
      }else{
        setContentCount(dataCount)
      }
      let newArr = []
      for (let i = pagesGroup - 1; i < pagesGroup + 4; i++) {
        if (i + 1 <= dataCount) {
          newArr.push(i + 1)
        }
      }
      if(newArr.length === 0) newArr = [1]
      setPageArr(newArr)
    }
    if (content.length > 0) {
      setDataList([...content])
    } else {
      setDataList(false)
    }
    setOnUpload(false)
  }

  const checkPk = async () => {
    if (carNumber === '') {
      return alert("차량번호를 입력해주세요.")
    }
    setOnUpload(true)
    const params = {
      number: carNumber,
    }
    const rs = await checkCarNumber(params)
    if (rs.data?.result === 'success') {
      setCarNumberConfirm(true)
    }
    alert(rs.data?.msg)
    setOnUpload(false)
  }

  const isValiddate = () => {
    if (carNumber === '') {
      return alert("차량번호를 입력해주세요.")
    } else if (carNumberConfirm === false) {
      return alert("차량번호 중복을 확인해주세요.")
    }
    return "success"
  }

  const saveCar = async () => {
    setOnUpload(true)
    const validdate = isValiddate();
    if (validdate !== 'success') {
      setOnUpload(false)
      return;
    }
    const params = {
      'number': carNumber,
      'company': companyId,
      'status': 'Y',
    }
    const rs = await saveCarNumber(params)
    if (rs.status === 201) {
      setModalShow2(false)
      setCarNumber('')
      setCarNumberConfirm(false)
      getDataList()
      alert('정상적으로 등록되었습니다.')
    } else {
      alert('등록에 실패했습니다.')
    }
    setOnUpload(false)
  }

  const uploadCarExcel = async () => {
    setOnUpload(true)
    if (carListFile == undefined || carListFile?.length == 0) { setOnUpload(false); return alert('파일을 등록하세요.') }
    try {
      const params = {
        type: 'xlsx',
        category: 'carListFile',
        company_id: companyId,
        member_id: myId
      }
      const fd = new FormData();
      fd.append('data', JSON.stringify(params));
      const newFile = new File([carListFile[0]], `${encodeURI(carListFile[0].name)}`, { type: carListFile[0].type })
      if (carListFile && !_.isEmpty(carListFile)) {
        fd.append('file_0', newFile);
      }

      const response = await saveCarExcel(fd)
      if (response.data?.result === 'success') {
        setIsRefresh(true)
        alert('정상적으로 등록되었습니다.')
      }

    } catch (e) {
      console.log(e)
    }
    setCarListFile([])
    setModalShow2(false)
    setOnUpload(false)
  }

  const deleteCar = async (item) => {
    if (confirm("해당 차량번호를 삭제하시겠습니까?")) {
      setOnUpload(true)
      {
        const params = {
          status: 'N'
        }
        const response = await deleteCarNumber(params, item.id);
        if (response?.status === 200) {
          setIsRefresh(true)
          alert('정상적으로 삭제되었습니다.')
        }
      }
      setOnUpload(false)
    }
    getDataList()
  }

  const fileDownload = async (str) => {
    let url = `https://waveradmin.ropiklabs.com/media/sample/${str}.xlsx`
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const excelUrl = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = excelUrl;
        link.setAttribute('download', `${str}.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error)
      })
  };

  const registFiles = (e) => {
    setCarListFile([...e.target.files])
  }

  const deleteFile = (item) => {
    setCarListFile(carListFile.filter(data => data !== item))
  }

  useEffect(() => {
    getDataList()
  }, [isRefresh, modalShow, modalShow2, page])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>차량번호 관리 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="마이웨버" breadcrumbItem="차량번호 관리" />

          {!modalShow && !modalShow2 &&
            <Row>
              <Col xs={12} className="waver-pagination-btn-group mb-4 text-end" style={{maxWidth: '25.625rem'}}>
                {/* <button className="waves-effect submit-btn btn btn-secondary zfont-size-16"
                  onClick={() => { setModalShow2(true) }}>일괄등록</button> */}
                <button className="waves-effect submit-btn btn btn-secondary zfont-size-16 margin-left-16" onClick={() => { setModalShow(true) }}
                >개별등록</button>
              </Col>
            </Row>
          }

          <Row>
            <Col xs={12} style={{maxWidth: '25.625rem'}}>
              <div className="email-rightbar mb-3">
                <Card className="overflow-hidden">

                  {!modalShow && !modalShow2 &&
                    <div className="radius-4 overflow-hidden">
                      <div className="table-responsive">
                        <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                          <thead className="chart-thead">
                            <tr>
                              <th scope="col" >차량번호</th>
                              <th scope="col" >삭제</th>
                            </tr>
                          </thead>
                          <tbody className="chart-tbody">
                            {dataList && dataList.map((item, index) => {
                              return (
                                <tr key={item.id + '_' + index}>
                                  <td>{item.number}</td>
                                  <td><i className="mdi mdi-trash-can-outline font-size-18 pointer" onClick={() => {
                                    deleteCar(item)
                                  }} /></td>
                                </tr>
                              )
                            })
                            }
                            {!dataList &&
                              <tr>
                                <td scope="row" colSpan="6">데이터가 없습니다.</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  }

                  {modalShow &&
                    <CardBody className="p-4">

                      <div className="d-flex">
                        <div style={{flexGrow: 1}}>
                          <p className="noMargin text-black font-weight-bold font-size-16">차량번호</p>
                          <input type="text" placeholder="차량번호를 입력해주세요." className="is-touched is-dirty av-valid form-control mt-2 font-size-16" onChange={(e) => { 
                            setCarNumber(e.target.value)
                            setCarNumberConfirm(false)
                          }} />
                        </div>
                        <div className="waver-pagination-btn-group" >
                          <button className="waves-effect submit-btn btn btn-secondary margin-top-35 margin-left-6 font-size-16"
                            onClick={() => {
                              checkPk()
                            }}
                          >중복확인</button>
                        </div>
                      </div>

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={() => {
                          saveCar()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {modalShow2 &&
                    <CardBody className="p-4">

                      <div className="download-container mt-2 d-flex flex-column justify-content-between" style={{ height: 'fit-content' }}>
                        <div className="d-flex align-items-top">
                          <Warning width={28} height={22} />
                          <p className="noMargin font-size-14 text-black padding-left-8">파일 업로드시, 기존 목록과 파일의 중복된 내용을 제외한 나머지 부분만 등록됩니다.  삭제는 개별 삭제 해주세요.</p>
                        </div>
                        <div className="waver-pagination-btn-group float-right d-flex justify-content-end">
                          <button className="waves-effect submit-btn btn btn-secondary font-size-14 mt-2"
                            onClick={() => {
                              fileDownload('차량번호등록엑셀')
                            }}
                          >샘플 엑셀파일 다운로드<Download className="margin-left-8" />
                          </button>
                        </div>
                      </div>

                      <label style={{ padding: '0.4rem 1rem', borderRadius: '0.2rem', margin: "18px 0", fontSize: 16 }} htmlFor="ex_file" className="btn btn-primary dropdown-toggle waves-effect waves-light">파일선택
                      </label>
                      <input style={{ display: "none" }} type="file" accept=".xls,.xlsx" id="ex_file" onChange={(e) => {
                        registFiles(e)
                      }} />

                      {carListFile.length > 0 && carListFile.map((item, index) => {
                        return (
                          <div className="file-confirm" key={index}>
                            <p className="noMargin">{item.name}</p>
                            <Delete className="margin-left-8 pointer" onClick={()=>{deleteFile(item)}} />
                          </div>
                        )
                      })}

                      <div className="d-flex mt-4 justify-content-end">
                        <button className="waves-effect btn btn-silver font-size-16" onClick={() => {
                          setModalShow2(false)
                        }}>취소</button>
                        <button className="waves-effect btn btn-primary font-size-16" onClick={async () => {
                          await uploadCarExcel()
                        }}>등록하기</button>
                      </div>

                    </CardBody>
                  }

                  {onUpload && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'5%'}></img>
                  </div>}

                </Card>

                {!modalShow && !modalShow2 &&
                  <Pagination contentCount={contentCount} pageArr={pageArr} pageCallBack={(page)=>{setPage(page)}} />
                }

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CarNumberManagementScreen